import script from "./SnippetList.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetList.vue?vue&type=script&setup=true&lang=js"

import "./SnippetList.vue?vue&type=style&index=0&id=b374d620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b374d620"]])

export default __exports__